"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base64Util = exports.jsonPrettyPrint = exports.isWorkgroupByType = exports.isWorkgroupByEmail = exports.isEmail = exports.getClientIp = exports.findSamlConfigByProvider = void 0;
/* Blast Imports */
var constants_1 = require("./constants");
// Get SAML configurations based on provider value
var findSamlConfigByProvider = function (config, samlProvider) {
    return config.saml.find(function (value) { return value.faspexConfigId === Number(samlProvider); });
};
exports.findSamlConfigByProvider = findSamlConfigByProvider;
// Gets the client/user's ip address from HTTP Request Header ('X-Forwarded-For')
var getClientIp = function (xForwardedFor) {
    if (xForwardedFor) {
        return xForwardedFor.split(",")[0].trim();
    }
    return undefined;
};
exports.getClientIp = getClientIp;
// Checks, if a valid email address
var isEmail = function (value) {
    return constants_1.EMAIL_REGEX.test(value.toLowerCase());
};
exports.isEmail = isEmail;
// Checks, if a workgroup, based on an email/name
var isWorkgroupByEmail = function (email) {
    return (email != undefined && email != null && email.startsWith(constants_1.ASTERISK) && !exports.isEmail(email));
};
exports.isWorkgroupByEmail = isWorkgroupByEmail;
// Checks, if a workgroup, based on a type
var isWorkgroupByType = function (type) {
    return (type === 'workgroup' || type === 'shared_inbox');
};
exports.isWorkgroupByType = isWorkgroupByType;
// Displays json object in a more readable fashion
var jsonPrettyPrint = function (json) {
    // pretty print with spacing set to 2
    return JSON.stringify(json, null, 2);
};
exports.jsonPrettyPrint = jsonPrettyPrint;
var Base64Util = /** @class */ (function () {
    function Base64Util() {
    }
    // Encodes a string using Base64
    Base64Util.toBase64 = function (token) {
        return Buffer.from(token).toString('base64');
    };
    // Decodes a string using Base64
    Base64Util.fromBase64 = function (token) {
        return Buffer.from(token, 'base64').toString('utf8');
    };
    return Base64Util;
}());
exports.Base64Util = Base64Util;
